import React, { useContext } from "react";
import { RootStoreContext } from "../../../app/stores/rootStore";

const SettlementFilterInfo = () => {
  //variables para uso la informacion del userStore
  const rootStore = useContext(RootStoreContext);
  const { getSettlementFilterInfo } = rootStore.reportStore;

  return (
    <div      
      dangerouslySetInnerHTML={{ __html: getSettlementFilterInfo() }}
    ></div>
  );
};

export default SettlementFilterInfo;
